import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccordionItemLink } from '../accordion/accordion-item.model';

@Component({
  selector: 'app-accordion-link',
  templateUrl: './accordion-link.component.html',
  styleUrls: ['./accordion-link.component.scss'],
  imports: [CommonModule]
})
export class AccordionLinkComponent {
  @Input() items: AccordionItemLink[] = [];
  activeIndex = -1;

  toggle(index: number): void {
    this.activeIndex = this.activeIndex === index ? -1 : index;
  }
}